<template>
  <div v-if="show" class="sidebar-links">
    <router-link :to="{name: 'Overview'}" exact>Overview</router-link>
    
    <router-link v-for="report in sidenavLinks" :key="report.id" :to="{name: report.name, params: { 'report_id': report.id }} " exact>{{report.name}}</router-link>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {reports: []}
  },
  computed: {
    ...mapGetters(['sidenavLinks']),

    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('/dashboard').test(this.path)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SideNav/DashboardLinks.vue